var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{pre:true,attrs:{"cx":"12","cy":"12","r":"10"}}),_c('path',{pre:true,attrs:{"d":"M12 16v-4"}}),_c('path',{pre:true,attrs:{"d":"M12 8h.01"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }